module.exports = __webpack_public_path__ + "assets/img/Culture_004.248fb5d4-ps.jpg";